import dayjs        from 'dayjs';
import { computed } from 'mobx';
import ApiModel     from './globals/ApiModel';

type WithUndefined<T> = {
  [P in keyof T]?: T[P] | undefined;
};

export default class DemandModel extends ApiModel {
  static get path() {
    return '/backend/demands/{?id}';
  }

  filters: WithUndefined<{
    'id': string;
    'stand.show': id;
    'stand.surface[gte]': number;
    'stand.surface[lte]': number;
  }> = {};

  @computed
  get formattedId() {
    return `D${String(this.id).padStart(4, '0')}`;
  }

  @computed
  get fullName() {
    return `${this.get('firstname')} ${this.get('lastname')}`;
  }

  @computed
  get askedDatetime() {
    return this.get('askedDatetime');
  }

  @computed
  get askedDatetimeDate() {
    return this.askedDatetime ? dayjs(this.askedDatetime) : null;
  }

  @computed
  get standId() {
    return this.get('stand.id');
  }

  @computed
  get demandTypeId() {
    return this.get('demandType.id');
  }

  @computed
  get demandTypeIri() {
    return this.get('demandType.@id');
  }

  @computed
  get demandStatusId() {
    return this.get('demandStatus.id');
  }

  @computed
  get comment() {
    return this.get('comment', '');
  }

  @computed
  get company() {
    return this.get('company', '');
  }

  @computed
  get email() {
    return this.get('email', '');
  }

  @computed
  get firstname() {
    return this.get('firstname', '');
  }

  @computed
  get lastname() {
    return this.get('lastname', '');
  }

  @computed
  get phone() {
    return this.get('phone', '');
  }

  @computed
  get unSeen() {
    return this.get('unSeen');
  }

  @computed
  get updatedAtDate() {
    return dayjs(this.get('updatedAt'));
  }
}
